import React from "react";
import { Spin, Tag, Tooltip } from "antd";

/**
 * Customer dashboard stats: three cards (Product, Environment, Submission types).
 * Uses Dashboard__StatsContainer / Dashboard__StatsCard styles from Customers.css.
 */
const CustomerSubmissionStats = ({
  customerOnboardedEsv,
  productPermissionEnabled,
  environmentPermissionEnabled,
  productTotalSamples,
  environmentTotalSamples,
  esvSubmissionsCount,
  otherSubmissionsCount,
  statsLoading,
  hasDateRangeSelected,
}) => {
  const renderStatValue = (hasData, content) => {
    if (!hasDateRangeSelected) {
      return <span className="Dashboard__StatsCard__Hint">Select date range</span>;
    }
    if (statsLoading) return <Spin size="small" />;
    if (!hasData) {
      return <span className="Dashboard__StatsCard__Hint">No Data</span>;
    }
    return content;
  };

  const hasSubmissionData = esvSubmissionsCount !== null || otherSubmissionsCount !== null;

  const submissionEsvTagTooltip = (() => {
    if (!hasDateRangeSelected) {
      return "Select a date range to load submission details.";
    }
    if (statsLoading) {
      return "Loading customer ESV status…";
    }
    if (!hasSubmissionData) {
      return "";
    }
    if (customerOnboardedEsv === true) {
      return "Customer onboarded on ESV";
    }
    return "Customer not onboarded on ESV";
  })();

  const submissionEsvTagStatus = customerOnboardedEsv === true ? "enabled" : "disabled";

  const StatCard = ({
    label, status, hasData, value, headerExtra,
  }) => (
    <div className="Dashboard__StatsCard">
      <div className="Dashboard__StatsCard__Row">
        <span className="Dashboard__StatsCard__Label">{label}</span>
        {headerExtra
          ?? (status ? (
            <Tag className={`Dashboard__StatsCard__Status Dashboard__StatsCard__Status--${status}`}>
              {status}
            </Tag>
          ) : null)}
      </div>
      <div className="Dashboard__StatsCard__Value">
        {renderStatValue(hasData, value)}
      </div>
    </div>
  );

  return (
    <div className="Dashboard__StatsContainer">
      <StatCard
        label="Submission Types"
        hasData={hasSubmissionData}
        headerExtra={(
          <Tooltip title={submissionEsvTagTooltip}>
            <span className="Dashboard__CustomerSubmissionStats__TagWrap">
              <Tag className={`Dashboard__StatsCard__Status Dashboard__StatsCard__Status--${submissionEsvTagStatus}`}>
                ESV
              </Tag>
            </span>
          </Tooltip>
        )}
        value={(
          <span className="Dashboard__StatsCard__Value">
            ESV:
            {" "}
            {esvSubmissionsCount ?? 0}
            {" | Others: "}
            {otherSubmissionsCount ?? 0}
          </span>
        )}
      />
      <StatCard
        label="Product"
        status={productPermissionEnabled ? "enabled" : "disabled"}
        hasData={productTotalSamples !== null}
        value={`${productTotalSamples} samples`}
      />
      <StatCard
        label="Environment"
        status={environmentPermissionEnabled ? "enabled" : "disabled"}
        hasData={environmentTotalSamples !== null}
        value={`${environmentTotalSamples} samples`}
      />
    </div>
  );
};

export default CustomerSubmissionStats;
